import {h, Fragment} from "preact"
import { useActions, useAppState, useProductFilters } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'
import SelectedFilters from './SelectedFilters'
import Facet from './Facet'
import RangeFacet from './RangeFacet'
import { customFacets } from '../config'

export default ({ resultsView, toggleSidebar, sidebarActive }) => {
    const { loading, response: { products: { facets } } = {} } = useAppState();
    const { updateSearch } = useActions();
    const { filters, removeAll } = useProductFilters();

    useEffect(() => {
        facets.forEach(facet => {
            const orderArr = customFacets.find(customFacet => customFacet.name === facet.name)?.order;
            if(orderArr && orderArr.length > 0) {
                facet.data.sort((a, b) => {
                    const aIndex = orderArr.indexOf(a.value);
                    const bIndex = orderArr.indexOf(b.value);
                    if (aIndex === -1) { return 1 }
                    if (bIndex === -1) { return -1 }
                    return aIndex - bIndex;
                })
            }
        })
    }, [facets])

    useEffect(() => {
        const handleSidebarScroll = (event) => {
            if(event.target.closest('.product-facet__filter-item').classList.contains('ns-active')) {
                const sidebar = window.document.querySelector('.ns-serp .ns-sidebar-menu');
                const scrollHeight = sidebar.scrollHeight;
                sidebar.scrollTo({ top: scrollHeight, behavior: 'smooth' })
            }
        };

        if(window.innerWidth < 1000) {
            const lastFacet = document.querySelector('.ns-serp .ns-sidebar-menu .product-facet__filter-item:last-child > .collapsible-toggle');
            lastFacet.addEventListener('click', handleSidebarScroll);
            return () => lastFacet.removeEventListener('click', handleSidebarScroll)
        }
    }, [facets?.length])

    return facets?.length > 0 ? (
        <>
            <div class={`ns-sidebar-wrapper ${sidebarActive ? 'active' : ''} ${resultsView && resultsView !== 'products' ? 'no-click' : ''}`}>
                <div class="ns-sidebar-content ns-relative">
                    <div class="ns-sidebar-header">
                        <p class="ns-sidebar-title">
                            Filters
                            {filters?.length > 0 && 
                                <span class="product-facet__active-count bubble-count mobile">{filters?.length}</span>
                            }
                        </p>
                        {filters?.length > 0 && 
                            <a class="drawer__header-action link text--subdued mobile" href="javascript:void(0)" onClick={removeAll}>Clear all</a>
                        }
                        <button type="button" class="ns-close-sidebar mobile" onClick={toggleSidebar}>
                            <svg focusable="false" width="14" height="14" class="icon icon--close" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.2" fill="none"></path></svg>
                        </button>
                    </div>
                    <SelectedFilters />
                    <div class="ns-sidebar-menu">
                        {facets?.map((facet, index) => {
                            if(facet.type === 'terms') {
                                return (index < (facets.length - 1) && index === (facets.length - 1))
                                    ?   <>
                                            <Facet facet={facet} />
                                        </>
                                    :   <Facet facet={facet} />
                            } else if (facet.type === 'stats') {
                                return <RangeFacet facet={facet} />
                            } else {
                                return null;
                            }
                        })}
                    </div>
                    <div class="ns-sidebar-footer drawer__footer drawer__footer--no-top-padding hidden-lap-and-up">
                        {/* <button type="button" class="button button--primary button--full" onClick={toggleSidebar}>View results</button> */}
                    </div>
                </div>
            </div>
            <div class="ns-sidebar-backdrop" onClick={toggleSidebar} />
        </>
    ) : null;
}